<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                    <a role="tab" data-toggle="tab" class="nav-link" @click.prevent="setActive('#t1'+rowData.docfis_id+'')" :class="{ active: isActive('#t1'+rowData.docfis_id+'') }" v-bind:href="'#t1'+rowData.docfis_id+''">Volumes</a>
                </li>
			</ul>

			<div class="tab-content">
                <div  role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" :class="{ 'active show': isActive('#t1'+rowData.docfis_id+'') }" v-bind:id="'#t1'+rowData.docfis_id+''">
                <table class="table-striped" id="mais">
                    <thead>
                        <tr>
                          <th data-toggle="true" style="width: 10%">N° Volume</th>
                          <th data-toggle="true" style="width: 10%">Status do Volume</th>
                          <th data-toggle="true" style="width: 20%">Usuario bip</th>
                          <th data-toggle="true" style="width: 20%">Data bip</th>
                        </tr>
                     </thead>

                     <tbody>
                         <tr class="bg-gray-light" style="display: table-row;" v-for='(item, index) in rowData.volumes'>

                           <td>
                               {{item.num_volume}}
                           </td>
                           <td>
                               <span class="badge badge-success" v-if="item.status_expedicao.valor==1">{{ item.status_expedicao.descr }}</span>
                               <span class="badge badge-danger" v-if="item.status_expedicao.valor==2">{{ item.status_expedicao.descr }}</span>
                               <span class="badge badge-warning" v-if="item.status_expedicao.valor==3">{{ item.status_expedicao.descr }}</span>
                           </td>
                           <td>
                               <span v-if="item.usuario_bip_expedicao != null">{{item.usuario_bip_expedicao.pessoa.pessoa_fisica.nome}}</span>
                           </td>
                           <td>
                             {{formatDate(item.dt_bip_expedicao)}}
                           </td>
                        </tr>
                    </tbody>
                </table>
        </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
</template>
<script>
    import accounting from 'accounting'
    import moment from "moment";

    export default {
      data () {
        return {
            abaAtiva: '',
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    mounted() {
        this.$parent.visibleDetailRows.forEach((item, i) => {
            this.abaAtiva = '#t1'+item+'';
        });
      },
    methods: {
        isActive (aba) {
            return this.abaAtiva === aba
        },
        setActive (aba) {
            this.abaAtiva = aba
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate(value, fmt = "DD/MM/YYYY HH:mm:ss") {
          return value == null ? "" : moment(value, "YYYY-MM-DD h:mm:ss").format(fmt);
        },
        onReloadVuetable() {
            this.$refs.vuetable.reload();
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },

  }
  </script>
